import { i18n } from '@/plugins/i18n';

const t = i18n.global.t;

export const convertTimestampToDate = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleString();
};

export const convertTimestampYYYYMMDD = (timestamp) => {
  const date = new Date(timestamp);
  return date.toISOString().slice(0, 10);
};

export const convertTimestampDD = (timestamp) => {
  const date = new Date(timestamp);
  return date.getDate();
};

export const convertTimestampMMDDHHMM = (timestamp) => {
  const date = new Date(timestamp);

  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${month}/${day} ${hours}:${minutes}`;
};

export const convertTimestampToYYMMDDW = (timestamp) => {
  const date = new Date(timestamp);

  const year = String(date.getFullYear()).slice(-2);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const weekday = [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')][date.getDay()];

  return `${year}. ${month}. ${day}(${weekday})`;
};

export const convertTimestampToTime = (timestamp) => {
  const date = new Date(timestamp);

  const hours = date.getHours();
  const displayHours = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;
  const minutes = date.getMinutes();
  const period = hours >= 12 ? t('label_pm') : t('label_am');

  return `${period} ${displayHours}:${String(minutes).padStart(2, '0')}`;
};
